import {getElementFromLocalStorage, setElementToLocalStorage} from 'app/helpers/webStorageUtility';
import {windowIsDefined} from 'app/helpers/windowIsDefined';

export const ALL_FILTERS = ['player', 'teamseason', 'competition', 'district', 'referee', 'news'];

const STORE_NAME = 'searchHistory';

export const getSearchHistory = () => {
  let storedHistory;
  if (windowIsDefined) {
    storedHistory = getElementFromLocalStorage(STORE_NAME);
  }
  return storedHistory ? JSON.parse(storedHistory) : [];
};

export const setSearchHistory = value => setElementToLocalStorage(STORE_NAME, value);

export const updateStoredSearchHistory = newValue => {
  const currentStoredHistory = getSearchHistory();
  const historyItems = currentStoredHistory.filter(item => item.slug !== newValue.slug);
  // limit search history to 10 items
  setSearchHistory(JSON.stringify([newValue, ...historyItems].slice(0, 10)));
};
